import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { DrawerMenu } from './components/DrawerMenu';
import { HomeScreen } from './screens/HomeScreen';
import { CantinaScreen } from './screens/CantinaScreen';
import { ScopertiScreen } from './screens/ScopertiScreen';
import { ProfiloScreen } from './screens/ProfiloScreen';
import { AcquistaScreen } from './screens/AcquistaScreen';
function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const getScreenTitle = () => {
    switch (activeTab) {
      case 'home':
        return 'Home';
      case 'cantina':
        return 'Esperienze';
      case 'scopri':
        return 'Scopri';
      case 'acquista':
        return 'Acquista';
      case 'profilo':
        return 'Profilo';
      default:
        return 'Home';
    }
  };
  const renderScreen = () => {
    switch (activeTab) {
      case 'home':
        return <HomeScreen data-id="element-0" />;
      case 'cantina':
        return <CantinaScreen onMenuClick={() => setIsDrawerOpen(true)} data-id="element-1" />;
      case 'scopri':
        return <ScopertiScreen data-id="element-2" />;
      case 'acquista':
        return <AcquistaScreen data-id="element-3" />;
      case 'profilo':
        return <ProfiloScreen data-id="element-4" />;
      default:
        return <HomeScreen data-id="element-5" />;
    }
  };
  // Hide header for cantina screen (which now shows experiences)
  const showHeader = activeTab !== 'cantina';
  return <div className="h-screen w-full flex flex-col bg-white overflow-hidden" data-id="element-6">
      {/* Header - Conditional */}
      {showHeader && <header className="flex items-center justify-between px-4 py-4 bg-white border-b border-gray-100 flex-shrink-0 z-30" data-id="element-7">
          <button onClick={() => setIsDrawerOpen(true)} className="p-2 -ml-2 text-gray-600 hover:text-gray-900 transition-colors" aria-label="Menu" data-id="element-8">
            <Menu size={20} strokeWidth={1.5} data-id="element-9" />
          </button>
          <h1 className="text-sm font-medium text-gray-900" data-id="element-10">
            {getScreenTitle()}
          </h1>
          <div className="w-9" data-id="element-11" />
        </header>}

      {/* Main Content Area */}
      <div className="flex-1 overflow-hidden" data-id="element-12">{renderScreen()}</div>

      {/* Drawer Menu */}
      <DrawerMenu isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} activeTab={activeTab} onTabChange={setActiveTab} data-id="element-13" />
    </div>;
}
export default App;